import Layout from '@/layout'

export const routerList = [
  {
    path: '/project',
    component: Layout,
    meta: {
      title: '项目',
      icon: 'icon-chanpinPIguanli-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/project/list',
        component: () => import('@/views/Project/Index'),
        name: 'ProjectIndex',
        meta: { title: '项目列表', affix: false }
      },
      {
        path: '/project/detail',
        component: () => import('@/views/Project/Detail'),
        name: 'ProjectDetail',
        hidden: true,
        meta: { title: '项目详情', affix: false }
      },
      {
        path: '/project/seal',
        component: () => import('@/views/Project/Seal'),
        name: 'ProjectSeal',
        meta: { title: '用印审批', affix: false }
      },
      {
        path: '/project/seal/detail',
        component: () => import('@/views/Project/SealDetail'),
        name: 'ProjectSealDetail',
        hidden: true,
        meta: { title: '用印审批详情', affix: false }
      },
      {
        path: '/project/invoiceApproval',
        component: () => import('@/views/Project/InvoiceApproval'),
        name: 'ProjectInvoiceApproval',
        meta: { title: '开票审批', affix: false }
      },
      {
        path: '/project/invoiceApproval/detail',
        component: () => import('@/views/Project/InvoiceApprovalDetail'),
        name: 'ProjectInvoiceApprovalDetail',
        hidden: true,
        meta: { title: '开票审批详情', affix: false }
      },
      {
        path: '/project/settlement',
        component: () => import('@/views/Project/Settlement'),
        name: 'ProjectSettlement',
        meta: { title: '结算', affix: false }
      },
      {
        path: '/project/settlement/detail',
        component: () => import('@/views/Project/SettlementDetail'),
        name: 'ProjectSettlementDetail',
        hidden: true,
        meta: { title: '结算详情', affix: false }
      }
    ]
  }
]
